import React, { useContext, useEffect, useState } from "react"
import moment from "moment-timezone"
import UserImage from "../UserImage"
import DatePicker from "./Date"
import TimePicker from "./Time"
import { SpaceProfileContext } from "../../context"

export default ({ space, calendar }) => {
  moment.tz.setDefault(moment.tz.guess())

  const {
    commonData: { contextDate, contextTime, contextMinDate, bookTourStep },
    actions: {
      setContextDate,
      setContextTime,
      setContextMinDate,
      setBookTourStep,
    },
  } = useContext(SpaceProfileContext)

  const [events, setEvents] = useState([])
  const [pickerDate, setPickerDate] = useState(
    moment(contextDate).isValid() && moment(contextDate).isAfter(moment())
      ? new Date(contextDate)
      : contextMinDate
  )

  const updateDatepicker = (newDate) => {
    setPickerDate(newDate)
    setBookTourStep(2)
    setContextDate(newDate)
  }

  const updateTimepicker = (newTime) => {
    setContextTime(newTime)
    setBookTourStep(3)
  }

  useEffect(() => {
    if (contextTime) {
      return
    }
    const tempSstartDate = moment
      .tz("America/Toronto")
      .add(calendar.calendar.notice, "hours")
      .format("YYYY-MM-DD HH:mm:ss")

    const startDate = moment(tempSstartDate, "YYYY-MM-DD HH:mm:ss")

    if (startDate.day() === 6) {
      startDate.add(2, "days")
    } else if (startDate.day() === 7) {
      startDate.add(1, "day")
    }

    // check if the start date is higher than the end time for the date
    const activeTime = calendar.calendar.available_times
      ? calendar.calendar.available_times.find(
          (time) => time.day === moment(startDate).format("dddd")
        )
      : []

    const dayEndTime =
      startDate && activeTime && activeTime.to
        ? moment(startDate.format("YYYY-MM-DD") + " " + activeTime.to).subtract(
            calendar.calendar.duration,
            "minutes"
          )
        : moment(startDate.format("YYYY-MM-DD") + " 4:00 pm")
    if (startDate.isAfter(dayEndTime)) {
      startDate.add(1, "day")
    }
    if (startDate.day() === 0) {
      startDate.add(1, "day")
    }
    if (startDate.day() === 6) {
      startDate.add(2, "days")
    }
    setContextDate(new Date(startDate))
    setPickerDate(new Date(startDate))

    setContextMinDate(new Date(startDate.format()))
  }, [])

  return (
    <div className={"date-time-picker"}>
      <div
        className={`date-picker text-center ${
          bookTourStep === 1 ? "d-inline-block" : "d-none"
        } d-lg-inline-block`}
      >
        <UserImage space={space} />
        <h5>{space.contact_name}</h5>
        {space.office_address && space.office_address.short_address && (
          <p className="title-sub">{space.office_address.short_address}</p>
        )}
        <DatePicker
          pickerDate={pickerDate}
          updateDatepicker={updateDatepicker}
          spCalendar={calendar.calendar}
          setEvents={setEvents}
          space={space}
          minDate={contextMinDate}
        />
        <p className="timezone">Eastern Time - Toronto</p>
      </div>
      <div
        className={`time-picker ${
          bookTourStep === 2 ? "d-inline-block" : "d-none"
        } d-lg-inline-block`}
      >
        <h5>Schedule a {calendar.calendar.duration || 30}-minute call</h5>
        <p className="title-sub">What time works best?</p>
        <TimePicker
          updateTimepicker={updateTimepicker}
          busy={calendar.busy}
          calendar={calendar.calendar}
          events={calendar.busy}
        />
      </div>
    </div>
  )
}
